import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, input } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';
import { ProductContextDisplayProperties } from 'ish-core/facades/product-context.facade';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';

@Component({
  selector: 'custom-dot-cms-product-carousel',
  templateUrl: './dot-cms-product-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsProductCarouselComponent implements DotCmsContentTypeComponent, OnInit, OnDestroy {
  readonly identifier = input<string>(undefined);
  contentlet$: Observable<CustomDotCmsContentlet>;
  productSKUs: string[] = [];
  displayProperties: Partial<ProductContextDisplayProperties>;
  triggerCount = 1;
  constructor(
    private dotCmsFacade: DotCmsFacade,
    private elementRef: ElementRef,
    private gtmFacade: GoogleTagManagerFacade
  ) {}
  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier());
    this.contentlet$.pipe(takeUntil(this.destroy$)).subscribe(item => {
      const gtmProduct: ProductView[] = item.productSkus.split(',').map(item => {
        const skus = item.trim();
        return { sku: skus };
      });
      this.gtmFacade.setupIntersectionObserverForGTMEvent(
        this.elementRef.nativeElement,
        gtmProduct,
        this.triggerCount,
        'view_item_list'
      );
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
